//import {useSelector} from 'react-redux';


//const userPermissions = useSelector((getState: ReturnType<typeof dcrReducer>) => getState.currentuserInfo?.user?.permissions);


const hasPermission = (permission: string,userPermissions: string[]) =>{

    if(userPermissions && userPermissions.length >0 && userPermissions.includes(permission)){
        return true;
    }
    return false;    
}



export { hasPermission };